import React, { useRef, useState } from "react";
import { Row, Spin } from "antd";
import { ConfirmationModal } from "./confirmationModal";
import { FileUploadInput } from "./fileUploadInput";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { downloadDocument } from "../../../constants/pdfDownloadHelper";

const Image = styled.img`
  display: block;
  width: 220px;
  height: 114px;
  border-radius: 8px;
  margin-bottom: 10px;
`;

const BtnLink = styled.button`
  color: #1890ff;
  text-decoration: underline;
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
  cursor: pointer;
  outline-color: transparent;
`;

export function PreviewImage({ src, show, onFileChange, removeImage, loading }) {
  const [modalVisible, setModalVisible] = useState(false);

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fileInput = useRef<any>(null);

  if (!src || !show) {
    return null;
  }

  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleNewUpload = () => {
    fileInput.current?.click();
  };

  const path = src.slice(0, src.indexOf("?"));

  const isSrcPdf = path.substr(path.length - 3) === "pdf";
  const name = path.substring(path.lastIndexOf("/") + 1);

  return (
    <Spin
      style={{
        width: "200px",
      }}
      spinning={loading}
    >
      {isSrcPdf ? (
        /* @ts-expect-error FIXME this wrong type */
        <Link
          style={{
            margin: 10,
            paddingTop: 10,
            paddingBottom: 10,
            display: "block",
          }}
          onClick={(e) => {
            e.preventDefault();
            void downloadDocument(src, name);
          }}
        >
          View pdf timesheet
        </Link>
      ) : (
        <Image src={src} alt="reference timesheet" />
      )}
      <Row>
        <FileUploadInput onChange={onFileChange} inputRef={fileInput} />
        <BtnLink onClick={handleNewUpload} style={{ marginRight: "48px" }}>
          Upload New Reference Timesheet
        </BtnLink>
        <BtnLink onClick={openModal}>Remove</BtnLink>
        <ConfirmationModal
          visible={modalVisible}
          removeImage={removeImage}
          closeModal={closeModal}
        />
      </Row>
    </Spin>
  );
}
